import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_wmIcons_6cd878d8 from 'nuxt_plugin_wmIcons_6cd878d8' // Source: ./wmIcons.js (mode: 'all')
import nuxt_plugin_nuxtplugina2d9c22e_ac34570c from 'nuxt_plugin_nuxtplugina2d9c22e_ac34570c' // Source: ./nuxt.plugin.a2d9c22e.js (mode: 'server')
import nuxt_plugin_image_aaba817e from 'nuxt_plugin_image_aaba817e' // Source: ./image.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_423d5d49 from 'nuxt_plugin_pluginseo_423d5d49' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_runtimeplugin8f1e9d12_28364756 from 'nuxt_plugin_runtimeplugin8f1e9d12_28364756' // Source: ./runtime.plugin.8f1e9d12.mjs (mode: 'all')
import nuxt_plugin_customerplugin_507efe19 from 'nuxt_plugin_customerplugin_507efe19' // Source: ./customer.plugin.js (mode: 'all')
import nuxt_plugin_runtimeplugindbfa95c0_083fd72a from 'nuxt_plugin_runtimeplugindbfa95c0_083fd72a' // Source: ./runtime.plugin.dbfa95c0.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin1aa132d4_4ca6a457 from 'nuxt_plugin_runtimeplugin1aa132d4_4ca6a457' // Source: ./runtime.plugin.1aa132d4.mjs (mode: 'all')
import nuxt_plugin_runtimepluginac2b9eca_6946aa64 from 'nuxt_plugin_runtimepluginac2b9eca_6946aa64' // Source: ./runtime.plugin.ac2b9eca.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin8c01af88_089a2479 from 'nuxt_plugin_runtimeplugin8c01af88_089a2479' // Source: ./runtime.plugin.8c01af88.mjs (mode: 'all')
import nuxt_plugin_runtimeplugin6d7494f0_925ae750 from 'nuxt_plugin_runtimeplugin6d7494f0_925ae750' // Source: ./runtime.plugin.6d7494f0.mjs (mode: 'all')
import nuxt_plugin_distplugin5cd6bd3c_02162cdc from 'nuxt_plugin_distplugin5cd6bd3c_02162cdc' // Source: ./dist.plugin.5cd6bd3c.mjs (mode: 'all')
import nuxt_plugin_pluginsfc2b674857_6718dcfd from 'nuxt_plugin_pluginsfc2b674857_6718dcfd' // Source: ./plugins.fc.2b674857.mjs (mode: 'all')
import nuxt_plugin_coreplugin2aa2e199_66ff8460 from 'nuxt_plugin_coreplugin2aa2e199_66ff8460' // Source: ./core.plugin.2aa2e199.ts (mode: 'all')
import nuxt_plugin_pluginstokenexpired3e850728_22c71cc1 from 'nuxt_plugin_pluginstokenexpired3e850728_22c71cc1' // Source: ./plugins.token-expired.3e850728.ts (mode: 'all')
import nuxt_plugin_pluginsdompurify4d814f2c_5269f4d1 from 'nuxt_plugin_pluginsdompurify4d814f2c_5269f4d1' // Source: ./plugins.dompurify.4d814f2c.ts (mode: 'all')
import nuxt_plugin_pluginsi18n5d77641f_c3f4b9a4 from 'nuxt_plugin_pluginsi18n5d77641f_c3f4b9a4' // Source: ./plugins.i18n.5d77641f.ts (mode: 'all')
import nuxt_plugin_pluginsfixLocaleRoutes2d1d1bc4_24d7f15e from 'nuxt_plugin_pluginsfixLocaleRoutes2d1d1bc4_24d7f15e' // Source: ./plugins.fixLocaleRoutes.2d1d1bc4.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting9fb4138e_05f914c3 from 'nuxt_plugin_pluginse2etesting9fb4138e_05f914c3' // Source: ./plugins.e2e-testing.9fb4138e.js (mode: 'all')
import nuxt_plugin_deviceplugin_7007b3d1 from 'nuxt_plugin_deviceplugin_7007b3d1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_6cf6843c from 'nuxt_plugin_workbox_6cf6843c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_313b02f5 from 'nuxt_plugin_metaplugin_313b02f5' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_35e2a869 from 'nuxt_plugin_iconplugin_35e2a869' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_storeConfigPlugin_cbd09bc6 from 'nuxt_plugin_storeConfigPlugin_cbd09bc6' // Source: ../node_modules/@wemade-vsf/core/lib/runtime/plugins/storeConfigPlugin.mjs (mode: 'server')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Partnermed","titleTemplate":"%s - Partnermed","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"hid":"og:site_name","property":"og:site_name","name":"og:site_name","content":"Partnermed"},{"hid":"og:title","name":"og:title","property":"og:title","content":"","template":(chunk) => chunk ? `${chunk} - Partnermed` : 'Partnermed'},{"hid":"og:description","property":"og:description","content":""},{"hid":"apple-mobile-web-app-title","property":"apple-mobile-web-app-title","content":"Partnermed"},{"name":"og:image","hid":"og:image","property":"og:image","content":"\u002Fogimage.jpg"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"bodyAttrs":{"id":"html-body"},"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_wmIcons_6cd878d8 === 'function') {
    await nuxt_plugin_wmIcons_6cd878d8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugina2d9c22e_ac34570c === 'function') {
    await nuxt_plugin_nuxtplugina2d9c22e_ac34570c(app.context, inject)
  }

  if (typeof nuxt_plugin_image_aaba817e === 'function') {
    await nuxt_plugin_image_aaba817e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_423d5d49 === 'function') {
    await nuxt_plugin_pluginseo_423d5d49(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin8f1e9d12_28364756 === 'function') {
    await nuxt_plugin_runtimeplugin8f1e9d12_28364756(app.context, inject)
  }

  if (typeof nuxt_plugin_customerplugin_507efe19 === 'function') {
    await nuxt_plugin_customerplugin_507efe19(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugindbfa95c0_083fd72a === 'function') {
    await nuxt_plugin_runtimeplugindbfa95c0_083fd72a(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin1aa132d4_4ca6a457 === 'function') {
    await nuxt_plugin_runtimeplugin1aa132d4_4ca6a457(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimepluginac2b9eca_6946aa64 === 'function') {
    await nuxt_plugin_runtimepluginac2b9eca_6946aa64(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin8c01af88_089a2479 === 'function') {
    await nuxt_plugin_runtimeplugin8c01af88_089a2479(app.context, inject)
  }

  if (typeof nuxt_plugin_runtimeplugin6d7494f0_925ae750 === 'function') {
    await nuxt_plugin_runtimeplugin6d7494f0_925ae750(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin5cd6bd3c_02162cdc === 'function') {
    await nuxt_plugin_distplugin5cd6bd3c_02162cdc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfc2b674857_6718dcfd === 'function') {
    await nuxt_plugin_pluginsfc2b674857_6718dcfd(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin2aa2e199_66ff8460 === 'function') {
    await nuxt_plugin_coreplugin2aa2e199_66ff8460(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginstokenexpired3e850728_22c71cc1 === 'function') {
    await nuxt_plugin_pluginstokenexpired3e850728_22c71cc1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsdompurify4d814f2c_5269f4d1 === 'function') {
    await nuxt_plugin_pluginsdompurify4d814f2c_5269f4d1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsi18n5d77641f_c3f4b9a4 === 'function') {
    await nuxt_plugin_pluginsi18n5d77641f_c3f4b9a4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsfixLocaleRoutes2d1d1bc4_24d7f15e === 'function') {
    await nuxt_plugin_pluginsfixLocaleRoutes2d1d1bc4_24d7f15e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting9fb4138e_05f914c3 === 'function') {
    await nuxt_plugin_pluginse2etesting9fb4138e_05f914c3(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7007b3d1 === 'function') {
    await nuxt_plugin_deviceplugin_7007b3d1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6cf6843c === 'function') {
    await nuxt_plugin_workbox_6cf6843c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_313b02f5 === 'function') {
    await nuxt_plugin_metaplugin_313b02f5(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_35e2a869 === 'function') {
    await nuxt_plugin_iconplugin_35e2a869(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_storeConfigPlugin_cbd09bc6 === 'function') {
    await nuxt_plugin_storeConfigPlugin_cbd09bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
